import { axiosInstance } from ".";

const getAdminsList = async (params) =>
  await axiosInstance.get("/admins", { params });

const addAdmin = async (payload) =>
  await axiosInstance.post("/admins", payload);

const getAdminDetails = async (id) => await axiosInstance.get(`/admins/${id}`);

const editAdmin = async ({id, data}) =>
  await axiosInstance.put(`/admins/${id}`, data);

const deleteAdmin = async ({ id }) =>
  await axiosInstance.delete(`/admins/${id}`);

export { getAdminsList, addAdmin, getAdminDetails, editAdmin, deleteAdmin };
